import React from 'react'
import store from '../store/Store'

import Navigation from '../components/navigation/Navigation'
import EditorContextMenu from '../components/editorContextMenu/EditorContextMenu'
import PageSelection from '../components/pageSelection/PageSelection'
import EditorTable from '../components/editorTable/EditorTable'
import EditorInformation from '../components/editorInformation/EditorInformation'
import EditorModal from '../components/editorModal/EditorModal'
import EditorTestArea from '../components/editorTestArea/EditorTestArea'

import { Redirect, withRouter } from 'react-router-dom'

import './editorTemplateView.scss'

type editorTemplateState = {
	article: any;
	navigation: any;
	history: any;
}

type editorTemplateProps = {
	article: any;
	navigation: any;
	history: any;
}

class EditorTemplateView extends React.Component<editorTemplateState, editorTemplateProps> {

	constructor(props) {
		super(props)

		// console.log(this.props)
		// console.log(this.props.history)

		this.state = {
			history: props.history,
			article: store.getState().article,
			navigation: store.getState().navigation
		}
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				article: store.getState().article,
				navigation: store.getState().navigation
			})
		})
	}

	componentWillUnmount() {
		store.subscribe(() => {
			this.setState({
				article: store.getState().article,
				navigation: store.getState().navigation
			})
		})
	}

	componentDidUpdate() {
		
	}

	render() {
		const { 
			article, 
			navigation,
			history
		} = this.state

		// console.log(article)
		// console.log(navigation)

		return (
			<div 
				className='EditorTemplateView'
			>

				<EditorTable
		          article={ article }
		          navigation={ navigation }
		        />

		        <EditorContextMenu
		          article={ article }
		          navigation={ navigation }
		          history={ history }
		        />

		        <EditorInformation
		          article={ article }
		          navigation={ navigation }
		        />

		        <PageSelection 
		          article={ article }
		        />

				<EditorModal
		          article={ article }
		          navigation={ navigation }
		        />

				{
					false ? (
						<EditorTestArea
				          article={ article }
				          navigation={ navigation }
				        />
					) : null
				}

			</div>
		)
	}
}

export default withRouter(EditorTemplateView)